import React from "react";

export class FileExist extends React.Component {
    render() {
        if (this.props.fileExist) {
            return null;
        }

        return (
            <span className="glyphicon glyphicon-warning-sign alert-no-file"
                  data-trigger="hover"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Файл отсутствует">
            </span>
        )
    }
}

export default FileExist;
